import React from 'react'
import { MultiSelect } from 'components'
import { useGetCategory } from 'hooks'

type CategoryProps = {
  categoryState: {
    category: string[]
    division?: string[]
    reportName?: string
  }
  onChange(category: string[], isDefaultAll?: boolean): void
  disabled?: boolean
}

export const SelectCategory = (props: CategoryProps) => {
  const { categoryState, onChange, disabled } = props
  const { category, division = ['all'], reportName } = categoryState

  const { getCategoryStatus, getIsCategoryLoading, categoryData, getCategoryError } = useGetCategory({
    division,
    reportName,
  })

  const isEnabled = !disabled && division.length

  const [fieldError, setFieldError] = React.useState('')
  const validateField = (setValidation: boolean = false) => {
    if (isEnabled) {
      if (getCategoryStatus === 'error') {
        return getCategoryError?.errorMessage ?? 'Network Error!'
      }
      if (!category.length) {
        if (fieldError) return true
        else if (setValidation) setFieldError('triggered')
      }
    }
    return ''
  }
  const getErrorText = () => {
    const value = validateField()
    if (typeof value === 'string') return value
    return ''
  }

  const handleCategoryChange = (
    selectedCategories: string[],
    selectedCategoriesText: string[],
    isDefaultAll?: boolean
  ) => {
    onChange(selectedCategories, isDefaultAll)
  }

  return (
    <div className="w-full sm:w-64" data-testid={`select-category`}>
      <MultiSelect
        placeholder="Select category"
        label="Category *"
        id="category"
        disabled={!isEnabled}
        isLoading={getIsCategoryLoading}
        value={category}
        onChange={handleCategoryChange}
        options={(categoryData || []).map((item) => ({
          text: item.commercial_category,
          value: item.commercial_category,
        }))}
        onBlur={() => validateField(true)}
        error={!!validateField()}
        helperText={getErrorText()}
      />
    </div>
  )
}
